
  <!-- Sidebar navigation [sidenavBreakpoint]="1601"  -->
  <mdb-side-nav #sidenav class="nav-bg fixed" [fixed]="true" >
       <div *ngIf="canShowHeader">
          <!-- Logo -->
        <li class="position-relative">
          <!-- <div class="logo-icon"><mdb-icon fas icon="clipboard-list" class="m-0 fa-2x text-dark"></mdb-icon></div> -->
          <div class="logo-wrapper waves-dark">
            <div style="position: absolute;margin: 8px">
              <switch-app-dropdown *axLazyElement="switchAppDropDownCdnUrl" [getToken]="sendToken" [incoming]="dropDownSendData" ></switch-app-dropdown>
            </div>
            <a href="javascript:void(0)"><img src="assets/img/TruTesta/TruAccreditation_icon.png" class="img-fluid flex-center"></a>
          </div>
        </li>

        <li>
          <ul class="collapsible collapsible-accordion">
            <mdb-accordion [multiple]="false" aria-multiselectable="false">

              <!-- Simple link -->
              <mdb-accordion-item class="no-collase">
                <mdb-accordion-item-head routerLink="accreditations" routerLinkActive="active" mdbWavesEffect>
                  <mdb-icon fas icon="user-tie" class="mr-0 pr-2"></mdb-icon>&nbsp;{{'administration_accreditations_label' | translate}}
                </mdb-accordion-item-head>
                <mdb-accordion-item-body></mdb-accordion-item-body>
              </mdb-accordion-item>

              <mdb-accordion-item>
                <mdb-accordion-item-head mdbWavesEffect>
                  <i class="fas fa-folder"></i> {{'administration_administration_label' | translate}}
                </mdb-accordion-item-head>
                <mdb-accordion-item-body>
                  <h5>{{'administration_accreditors_label' | translate}}</h5>
                  <ul>
                    <li><a routerLink="business-lines" routerLinkActive="active" href="javascript:void(0)"
                        mdbWavesEffect>{{'administration_businessLines_label' | translate}}</a></li>
                    <li><a routerLink="site-identifier-tags" routerLinkActive="active" href="javascript:void(0)"
                        mdbWavesEffect>{{'administration_siteIdentifierTags_label' | translate}}</a></li>
                    <li><a routerLink="geography-tags" routerLinkActive="active" href="javascript:void(0)"
                        mdbWavesEffect>{{'administration_geographicIdTags_label' | translate}}</a></li>
                    <li><a routerLink="accreditors" routerLinkActive="active" href="javascript:void(0)"
                        mdbWavesEffect>{{'administration_accreditors_label' | translate}}</a></li>
                  </ul>
                  <h5>{{'administration_components_label' | translate}}</h5>
                  <ul>
                    <li><a routerLink="certificate-components" routerLinkActive="active" href="javascript:void(0)"
                        mdbWavesEffect>{{'administration_certificateComponents_label' | translate}}</a></li>
                    <li><a routerLink="certificate-component-schemes" routerLinkActive="active" href="javascript:void(0)" mdbWavesEffect
                        style="line-height:16px">{{'administration_certificateComponentScheme_label' | translate}}</a></li>
                  </ul>
                  <h5>{{'administration_revisionSetup_label' | translate}}</h5>
                  <ul>
                    <li><a routerLink="revision-types" routerLinkActive="active" href="javascript:void(0)"
                        mdbWavesEffect>{{'administration_revisionTypes_label' | translate}}</a></li>
                    <li><a routerLink="revision-schemes" routerLinkActive="active" href="javascript:void(0)"
                        mdbWavesEffect>{{'administration_revisionSchemes_label' | translate}}</a></li>
                  </ul>
                  <h5>{{'administration_certifications_label' | translate}}</h5>
                  <ul>
                    <li><a routerLink="programs" routerLinkActive="active" href="javascript:void(0)"
                        mdbWavesEffect>{{'administration_programs_label' | translate}}</a></li>
                    <li><a routerLink="certificate-actions" routerLinkActive="active" href="javascript:void(0)"
                        mdbWavesEffect>{{'administration_actions_label' | translate}}</a></li>
                    <li><a routerLink="certification-mark-types" routerLinkActive="active" href="javascript:void(0)"
                        mdbWavesEffect>{{'administration_certificationMarkTypes_label' | translate}}</a></li>
                    <li><a routerLink="certification-mark-tags" routerLinkActive="active" href="javascript:void(0)"
                        mdbWavesEffect>{{'administration_certificationMarkTags_label' | translate}}</a></li>
                    <li><a routerLink="certification-marks" routerLinkActive="active" href="javascript:void(0)"
                        mdbWavesEffect>{{'administration_certificationMarks_label' | translate}}</a></li>
                    <li><a routerLink="certification-body-types" routerLinkActive="active" href="javascript:void(0)"
                        mdbWavesEffect>{{'administration_certificationBodyTypes_label' | translate}}</a></li>
                    <li><a routerLink="certification-bodies" routerLinkActive="active" href="javascript:void(0)"
                        mdbWavesEffect>{{'administration_certificationBodies_label' | translate}}</a></li>
                    <li><a routerLink="certificate-regions" routerLinkActive="active" href="javascript:void(0)"
                        mdbWavesEffect>{{'administration_certificationRegions_label' | translate}}</a></li>
                  </ul>
                  <h5>{{'administration_calendar_label' | translate}}</h5>
                  <ul>
                    <li><a routerLink="event-types" routerLinkActive="active" href="javascript:void(0)"
                      mdbWavesEffect>{{'administration_eventTypes_label' | translate}}</a></li>
                  </ul>
                </mdb-accordion-item-body>
              </mdb-accordion-item>

              <mdb-accordion-item class="no-collase">
                <mdb-accordion-item-head routerLink="accreditation-calendar" routerLinkActive="active" mdbWavesEffect>
                  <mdb-icon fas icon="calendar-alt" class="mr-0 pr-2"></mdb-icon>{{'administration_accredCal_label' | translate}}
                </mdb-accordion-item-head>
                <mdb-accordion-item-body></mdb-accordion-item-body>
              </mdb-accordion-item>

              <mdb-accordion-item class="no-collase">
                <mdb-accordion-item-head routerLink="dashboard" routerLinkActive="active" mdbWavesEffect>
                  <mdb-icon fas icon="tachometer-alt" class="mr-0 pr-2"></mdb-icon>{{'main_nav_dashboard_label' | translate}}
                </mdb-accordion-item-head>
                <mdb-accordion-item-body></mdb-accordion-item-body>
              </mdb-accordion-item>

            </mdb-accordion>
          </ul>
        </li>
        <!--/. Side navigation links -->
        <div class="sidenav-bg mask-strong"></div>
       </div>
      </mdb-side-nav>
    <!--/. Sidebar navigation -->

    <!-- Navbar -->
      <mdb-navbar  SideClass="navbar navbar-expand-md scrolling-navbar double-nav" [containerInside]="false">
        <navlinks class="navbar-container">
            <!-- SideNav slide-out button -->
            <div class="float-xs-left" *ngIf="canShowHeader">
                <a (click)="sidenav.toggle()" class="button-collapse-non-fixed">
                    <mdb-icon fas icon="bars"></mdb-icon>
                </a>
            </div>
            <!--/. SideNav slide-out button -->
        </navlinks>
        <logo>
            <!-- Breadcrumb-->
            <div class="breadcrumbs breadcrumb-dn mr-auto">
              <p style="font-size:24px;color:#999" ><span style="font-family:'KeepCalm';color:#444">Tru</span><span style="font-family:'KeepCalm';color:#729bbc">Accreditation</span><sup style="font-size:60%">&trade;</sup></p>
            </div>
            <!--/. Breadcrumb-->
        </logo>
        <navlinks>
            <ul class="nav navbar-nav nav-flex-icons ml-auto ie-double-nav">
                <li class="nav-item" *ngIf="canShowHeader">
                  <upload-icon [sprigInfo]="defaultSprigInfo"></upload-icon>
                </li>
                <li class="nav-item" *ngIf="canShowHeader">
                  &nbsp;
                </li>
                <li class="nav-item dropdown btn-group" dropdown>
                    <a class="nav-link waves-light dropdown-toggle" mdbWavesEffect dropdownToggle type="button" >
                        <div class="people_avatar-container">
                            <span class="people_avatar">
                                <img ngxGravatar [email]="'userEmailAddress'" [size]="31" [fallback]="'blank'" />
                            </span>
                            <div class="people_fallbackInitial">{{loggedInUserInitials}}</div>
                        </div>
                      <span class="clearfix d-none d-sm-inline-block">{{user}}</span>
                    </a>
                    <div class="dropdown-menu dropdown-ins dropdown-menu-right" role="menu">
                        <a *ngIf="canShowHeader" class="dropdown-item " href="javascript:void(0)" (click)=" openUserPreferencesModal()">
                          <mdb-icon fas icon="user-cog" class=" mr-1" style="font-size:1.1rem"></mdb-icon>
                          {{ 'header_userPreferences_label' | translate }}
                        </a>
                        <a class="dropdown-item " href="javascript:void(0)" (click)="logout()">{{'main_nav_logOut_label' | translate}}</a>
                    </div>
                </li>
                <li class="nav-item" (click)="toggleShowDrawer()" *ngIf="canShowHeader">
                  <a class="nav-link waves-light" mdbWavesEffect href="javascript:void(0)">
                      <mdb-icon fas icon="bell"></mdb-icon>
                      <div class="badge-count-label badge badge-danger" *ngIf="msgCount>0">{{msgCount}}</div>
                  </a>
                </li>
            </ul>
        </navlinks>
      </mdb-navbar>
    <!--/. Navbar -->

    <user-preferences-modal [endpoint]="endpoints" [incoming]="userPreferencesData"
      (sprigInfoEmitter)="getSprigInfo($event)" (changedLanguage)="langChanged($event)"
      (toastMessage)="toastMessages($event)" *axLazyElement="userPreferenceCdnUrl" [getToken]="sendToken">
    </user-preferences-modal>

    <notify-card *axLazyElement="notificationCompCdnUrl" [(incoming)]="notificationInfo" (updateNotificationCount)="notificationCount()"
    (outgoing)="closeNotification($event)"></notify-card>

    <common-document-warning-modal (outputEmit)="setUserPreferenceModalData()" [modalDetails]="sprigWarningData"></common-document-warning-modal>